import { render, staticRenderFns } from "./Component-RealtimeCall.vue?vue&type=template&id=77606e85&"
import script from "./Component-RealtimeCall.vue?vue&type=script&lang=js&"
export * from "./Component-RealtimeCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports